import type { NextPage } from 'next'
import Head from 'next/head'

// import Inheritors from '@/components/dashboard'
import SetUpInheritanceComponent from '@/components/set-up-inheritance'

const SetUpInheritance: NextPage = () => {
  return (
    <>
      <Head>
        <title>{'Inherit Wallet - Set up inheritance'}</title>
      </Head>

      <main>
        <SetUpInheritanceComponent />
      </main>
    </>
  )
}

export default SetUpInheritance
